export default "/assets/images/mila-room-showcase-sm-01.webp?cd0bd6ce83cec7ef56712f75b102e15a";